/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BulkSaleLoadingReportPaginationResponseDto } from '../model/bulkSaleLoadingReportPaginationResponseDto';
import { FranchiseRegistrationReportPaginationResponseDto } from '../model/franchiseRegistrationReportPaginationResponseDto';
import { InventoryQuantityReportPaginationResponseDto } from '../model/inventoryQuantityReportPaginationResponseDto';
import { MemberRegistrationReportPaginationResponseDto } from '../model/memberRegistrationReportPaginationResponseDto';
import { PurchaseActivityReportResponseDto } from '../model/purchaseActivityReportResponseDto';
import { PurchaseReportPaginationResponseDto } from '../model/purchaseReportPaginationResponseDto';
import { ValidationError } from '../model/validationError';

export enum reportsWebUiFranchiseRegistrationGetDataViewEnum {
  quantity = 'quantity',
  amount = 'amount',
  list = 'list',
}
export enum reportsWebUiFranchiseRegistrationGetTimeScopeEnum {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum reportsWebUiInventoryQuantityGetDimensionEnum {
  all = 'all',
  product = 'product',
  all_branch = 'all_branch',
  wpn_branch = 'wpn_branch',
  franchise_branch = 'franchise_branch',
}
export enum reportsWebUiInventoryQuantityGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum reportsWebUiMemberRegistrationGetDataViewEnum {
  quantity = 'quantity',
  amount = 'amount',
  list = 'list',
}
export enum reportsWebUiMemberRegistrationGetTimeScopeEnum {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum reportsWebUiPurchaseActivitySummaryGetTimeScopeEnum {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum reportsWebUiPurchaseActivitySummaryGetDataViewEnum {
  quantity = 'quantity',
  amount = 'amount',
  list = 'list',
}
export enum reportsWebUiPurchaseActivitySummaryGetSellerEnum {
  all = 'all',
  member = 'member',
  franchise = 'franchise',
}
export enum reportsWebUiPurchaseActivitySummaryGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum reportsWebUiPurchaseSummaryGetTimeScopeEnum {
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum reportsWebUiPurchaseSummaryGetDataViewEnum {
  quantity = 'quantity',
  amount = 'amount',
  list = 'list',
}
export enum reportsWebUiPurchaseSummaryGetDimensionEnum {
  all = 'all',
  product = 'product',
  all_branch = 'all_branch',
  wpn_branch = 'wpn_branch',
  franchise_branch = 'franchise_branch',
}
export enum reportsWebUiPurchaseSummaryGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class ReportsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public reportsWebUiBulkSaleLoadingGet$(page?: number, limit?: number, purchaseNo?: string, carLicensePlate?: string, fromDate?: string, toDate?: string, bulkSaleBranchId?: string, productName?: string, pricePerUnit?: number, sumAmount?: number, sort?: string): Observable<BulkSaleLoadingReportPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/bulk-sale-loading`, { page, limit, purchaseNo, carLicensePlate, fromDate, toDate, bulkSaleBranchId, productName, pricePerUnit, sumAmount, sort });
  }
  /**
   * [Authorize] type: http
   */
  public reportsWebUiFranchiseRegistrationGet$(page?: number, limit?: number, dataView?: string, timeScope?: string, fromDate?: string, toDate?: string, sort?: string): Observable<FranchiseRegistrationReportPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/franchise-registration`, { page, limit, dataView, timeScope, fromDate, toDate, sort });
  }
  /**
   * [Authorize] type: http
   */
  public reportsWebUiInventoryQuantityGet$(page?: number, limit?: number, dimension?: string, wpnBranchIds?: Array<string>, franchiseBranchIds?: Array<string>, productCategoryIds?: Array<string>, productIds?: Array<string>, language?: string, sort?: string): Observable<InventoryQuantityReportPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/inventory-quantity`, { page, limit, dimension, wpnBranchIds, franchiseBranchIds, productCategoryIds, productIds, language, sort });
  }
  /**
   * [Authorize] type: http
   */
  public reportsWebUiMemberRegistrationGet$(page?: number, limit?: number, dataView?: string, timeScope?: string, fromDate?: string, toDate?: string, sort?: string): Observable<MemberRegistrationReportPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/member-registration`, { page, limit, dataView, timeScope, fromDate, toDate, sort });
  }
  /**
   * [Authorize] type: http
   */
  public reportsWebUiPurchaseActivitySummaryGet$(page?: number, limit?: number, timeScope?: string, dataView?: string, seller?: string, fromDate?: string, toDate?: string, splitTier?: boolean, language?: string, sort?: string): Observable<PurchaseActivityReportResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/purchase-activity-summary`, { page, limit, timeScope, dataView, seller, fromDate, toDate, splitTier, language, sort });
  }
  /**
   * [Authorize] type: http
   */
  public reportsWebUiPurchaseSummaryGet$(page?: number, limit?: number, timeScope?: string, dataView?: string, dimension?: string, fromDate?: string, toDate?: string, productCategoryIds?: Array<string>, productIds?: Array<string>, wpnBranchIds?: Array<string>, franchiseBranchIds?: Array<string>, language?: string, sort?: string): Observable<PurchaseReportPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/reports/web-ui/purchase-summary`, { page, limit, timeScope, dataView, dimension, fromDate, toDate, productCategoryIds, productIds, wpnBranchIds, franchiseBranchIds, language, sort });
  }
}
